module.exports = __webpack_public_path__ + "img/frame-right.2be85be5.png";